import React from 'react';
import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const StyledTable = styled.table`
  min-width: 100%;
`;

const Thead = styled.thead`
  background-color: rgba(242, 244, 247, 0.05);
`;

const SubHeader = styled.thead`
  background-color: rgba(255, 255, 255, 0.1);
`;

const Th = styled.th`
  white-space: nowrap;
  padding: 0.25rem 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-align: left;
  color: #98a2b3;
  font-family: Arial, sans-serif;
`;

const Td = styled.td`
  padding: 0.5rem 1rem;
  white-space: nowrap;
`;

const Tbody = styled.tbody`
  & > tr {
    border-bottom: 1px solid #1f2937;
  }
`;

const Table = ({ data, columns, showHeader = true, subheader = '', className = '' }) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel()
  });

  return (
    <TableContainer className={className}>
      <StyledTable>
        {showHeader && (
          <Thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <Th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(header.column.columnDef.header, header.getContext())}
                  </Th>
                ))}
              </tr>
            ))}
          </Thead>
        )}
        {subheader && (
          <SubHeader>
            <tr>
              <Th colSpan={100}>{subheader}</Th>
            </tr>
          </SubHeader>
        )}
        <Tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
              ))}
            </tr>
          ))}
        </Tbody>
      </StyledTable>
    </TableContainer>
  );
};

export default Table;
